import type { BuxusOperatorPayload } from "./types";

/**
 * Legacy GET payload sometimes places `contacts` / `assets` beside `operator`.
 * Shared sitemap paths read `operator.*`; fold root arrays onto `operator` when needed.
 */
export function normalizeLegacyOperatorPayload(payload: BuxusOperatorPayload): BuxusOperatorPayload {
  const p = payload as BuxusOperatorPayload & { assets?: unknown[]; contacts?: unknown[] };
  const opRec = p.operator as Record<string, unknown>;
  if (Array.isArray(p.contacts) && p.contacts.length > 0) {
    if (!Array.isArray(opRec.contacts) || opRec.contacts.length === 0) {
      opRec.contacts = p.contacts;
    }
  }
  if (Array.isArray(p.assets) && !Array.isArray(opRec.assets)) {
    opRec.assets = p.assets;
  }
  return payload;
}
